module.exports = {
      id: "icon-login-usage",
      viewBox: "0 0 10.66 10.66",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#icon-login",
      toString: function () {
        return this.url;
      }
    }